import { useHasPermission } from "@/features/auth/hooks/usePermission";

const useCanPlayPickems = () => {
  const submitPickems = useHasPermission("submitPickems");
  const canSubmitPromoCashPickems = useHasPermission(
    "submitPickemsAwardingPromoCash",
  );
  const canSubmitRealCashPickems = useHasPermission(
    "submitPickemsAwardingRealCash",
  );
  return (
    submitPickems && (canSubmitPromoCashPickems || canSubmitRealCashPickems)
  );
};

export default useCanPlayPickems;
